import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import './section.css'
import Spaces from "../../pages/spaces/spaces";
import Article from "../../pages/article/article";
import ChatThreads from "../../pages/chat-threads/chat-threads";
import Conversation from "../../pages/conversation/conversation";
import ExpensesDashboard from "../../pages/expenses/expenses";

import { connect } from "react-redux";
import { AnimatePresence, motion } from 'framer-motion';
import Pluto from "../Pluto/Pluto.js";
import useUser from "../../hooks/useUser";

// const prefetchImages = (urls) => {
//     urls.forEach((url) => {
//         const img = new Image();
//         img.src = url;
//     });
// };

function Section({ isOpen, contents, user }) {
    const { isAdmin } = useUser();
    // const [loaded, setLoaded] = useState(false);
    // const [logged, setLogged] = useState(false);

    // useEffect(() => {
    //     if (user.isLogged) {
    //         setLogged(true);
    //     }
    // }, [user]);

    // useEffect(() => {
    //     if (logged) {
    //         setTimeout(() => {
    //             setLoaded(true)
    //         }, 1000)
    //     }
    // }, [logged]);

    // useEffect(() => {

    //     // Prefetch images
    //     const imageUrls = (contents?.items || []).map(
    //         (news) => news?.asset?.fields?.file?.url
    //     );
    //     prefetchImages(imageUrls);
    // }, [contents]);

    const _baseClass = "section";

    return (
        <div className={_baseClass + (!isOpen ? ' collapsed pl-0 w-full h-[calc(100% - 70px)]' : ' pl-[100%] lg:pl-[236px] w-full overflow-hidden h-[calc(100% - 70px)]')}>
            <AnimatePresence>
                <motion.div
                    className="sm:rounded-[10px] mt-0 sm:m-[50px] sm:mt-[20px] lg:mt-[20px] min-h-[calc(100vh-60px)] h-[calc(100vh-60px)] sm:min-h-[calc(100vh-130px)] sm:h-[calc(100vh-130px)] xl:min-h-[calc(100vh-70px)] xl:h-[calc(100vh-70px)]"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0.5 }}
                    transition={{ duration: 1.5, ease: 'easeOut' }}
                >
                    <Routes>
                        <Route path="/:timeline?" element={<Spaces />} /> {/* 👈 Renders at /app/ */}
                        <Route path="/article/:id" element={<Article />} /> {/* 👈 Renders at /app/ */}
                        <Route path="/chat-threads" element={<ChatThreads />} /> {/* 👈 Renders at /app/ */}
                        <Route path="/chat-threads/:id" element={<Conversation />} /> {/* 👈 Renders at /app/ */}
                        <Route path="/pluto" element={isAdmin ? <Pluto /> : <Navigate replace to="/" />} /> {/* 👈 Renders at /app/ */}
                        <Route path="/expenses" element={isAdmin ? <ExpensesDashboard /> : <Navigate replace to="/" />} />
                        <Route path="*" element={<Navigate replace to="/" />} />
                    </Routes>
                </motion.div>
            </AnimatePresence>

            <AnimatePresence>
                <motion.div
                    className="bg-white-200 flex justify-center items-center h-full w-full absolute left-0 z-50"
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 0, display: 'none' }}
                    transition={{ duration: 1.5, ease: 'easeInOut' }}
                >
                    <div className="flex justify-center items-center flex-col">
                        <img src="/assets/kps-loader.gif" alt="" className="h-[200px] w-[200px]" />
                    </div>
                </motion.div>
            </AnimatePresence>
        </div>
    );
}

const mapStateToProps = state => ({
    contents: state.contents,
    user: state.user
});

export default connect(mapStateToProps)(Section)
